import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDisclosure } from "../utils";
export function ToggleButton(_param) {
    var heading = _param.heading, content = _param.content, _pl = _param.pl, pl = _pl === void 0 ? "24px" : _pl, _className = _param.className, className = _className === void 0 ? "" : _className, _initialIsOpen = _param.initialIsOpen, initialIsOpen = _initialIsOpen === void 0 ? false : _initialIsOpen, rest = _object_without_properties(_param, [
        "heading",
        "content",
        "pl",
        "className",
        "initialIsOpen"
    ]);
    var ref = useDisclosure(initialIsOpen), isOpen = ref.isOpen, toggle = ref.toggle;
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: className
    }, rest), {
        children: [
            /*#__PURE__*/ _jsxs("button", {
                type: "button",
                className: "appearance-none font-medium space-x-2 text-left py-1",
                onClick: toggle,
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        style: {
                            transform: isOpen ? "rotate(90deg)" : "",
                            width: "14px",
                            height: "14px",
                            marginBottom: "2px",
                            display: "inline"
                        }
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "[&>*]:inline",
                        children: heading
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    display: isOpen ? "block" : "none",
                    paddingLeft: pl
                },
                className: "whitespace-pre-wrap leading-relaxed",
                children: content
            })
        ]
    }));
}
export function Icon(props) {
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M8 5v14l11-7z"
        })
    }));
}
